import { captureException } from '@chilipiper/sentry'
import { TimezoneId, timezones } from './timezone'
import { normalizeTimezone, timezoneCouldFail } from './helpers'

const getTimezone = () => {
  const browserTimezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || 'UTC'
  try {
    return sessionStorage.getItem('CYPRESS_TIMEZONE') || browserTimezone
  } catch (err) {
    // Some browsers might not give access to session storage
    return browserTimezone
  }
}

export const getClientTimezone = () => {
  const currentTimezone = normalizeTimezone(getTimezone())
  if (timezones.has(currentTimezone as TimezoneId)) {
    return currentTimezone
  }

  const now = new Date()
  const getDateWithTimezone = (tz?: string) => {
    try {
      return now.toLocaleTimeString('default', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: tz,
      })
    } catch (e) {
      const message = `Timezone data not found for ${tz}`
      console.warn(message)
      if (!tz || !timezoneCouldFail(tz)) {
        captureException(new Error(message, { cause: e }))
      }
      return 'unknown'
    }
  }
  const currentDate = getDateWithTimezone()
  return (
    Array.from(timezones.values()).find(zone => {
      const timezoneDate = getDateWithTimezone(zone)
      return timezoneDate === currentDate
    }) || currentTimezone
  )
}
